<template>
  <div>
    <!-- 面包屑导航 -->
<!--    <el-breadcrumb separator-class="el-icon-arrow-right">-->
<!--      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>-->
<!--      <el-breadcrumb-item>车辆年审到期提醒</el-breadcrumb-item>-->
<!--    </el-breadcrumb>-->
    <!-- 卡片 -->
    <el-card class="box-card">
      <!-- 搜索  新增-->
      <el-row :gutter="24">
        <el-col :span="10">
          <el-form
            :inline="true"
            :model="searchForm"
            :rules="searchRules"
            ref="searchForRef"
            autocomplete="on"
          >
            <el-form-item label="关键字" size="small" label-width="70px">
              <el-input v-model="searchForm.name" @click.native="chooseCar" placeholder="请输入车牌号/联系人电话" clearable type="text"></el-input>
            </el-form-item>

          </el-form>
        </el-col>
        <el-col :span="1">
          <el-button size="small" type="success" @click="searchSubmit()">搜索</el-button>
          <!-- <el-button @click="searchRest()">重置</el-button> -->
        </el-col>
        <!--
        <el-col :span="1">
          <el-button size="small" type="primary" @click="addData">新增</el-button>
        </el-col>-->
      </el-row>

      <!-- 表格 -->
      <el-table ref="multipleTable" :data="tableLoadData" stripe border size="mini" :header-cell-style="{background:'#e5e5e5',color:'#333333'}">
        <el-table-column
            label="ID"
            min-width="5%"
            prop="id"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column
            label="经办人"
            min-width="10%"
            prop="op_name"
            :show-overflow-tooltip='true'>
        </el-table-column>

        <el-table-column
            label="车牌"
            min-width="10%"
            prop="plate_number"
            :show-overflow-tooltip='true'>
        </el-table-column>

        <el-table-column
            label="车主"
            min-width="10%"
            prop="allPerson"
            :show-overflow-tooltip='true'>
        </el-table-column>

        <el-table-column
            label="等级名称"
            min-width="10%"
            prop="name"
            :show-overflow-tooltip='true'>
        </el-table-column>

        <el-table-column
            label="联系电话"
            min-width="10%"
            prop="mobile"
            :show-overflow-tooltip='true'>
        </el-table-column>

        <el-table-column
            label="收费金额"
            min-width="10%"
            prop="fee"
            :show-overflow-tooltip='true'>
        </el-table-column>

        <el-table-column
            label="评定人姓名"
            min-width="10%"
            prop="audit_name"
            :show-overflow-tooltip='true'>
        </el-table-column>

        <el-table-column
            label="下次评定日期"
            min-width="10%"
            prop="next_time"
            :show-overflow-tooltip='true'>
          <template slot-scope="scope">{{ scope.row.next_time | dateFormat }}</template>
        </el-table-column>

        <el-table-column
            label="备注"
            min-width="10%"
            prop="remark"
            :show-overflow-tooltip='true'>
        </el-table-column>
        <!--
        <el-table-column
            label="操作"
            fixed="right"
            width="130">
          <template slot-scope="scope">
            <el-button type="warning" size="mini" icon="el-icon-edit" @click="handelEdit(scope.row)"></el-button>
            <el-button type="danger" size="mini" icon="el-icon-delete" @click="handelDel(scope.row)"></el-button>
          </template>
        </el-table-column>
        -->
      </el-table>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>

  </div>
</template>

<script>
  import eTable from "../common/eTable.vue";
  import moment from 'moment';    //日期时间转换
  import eCar from "../common/eCar";
  export default {
    name: "annuaDue",
    components: {
      eTable,
      eCar
    },
    props: {},
    data() {
      return {
        isShowCar:false,
        // 搜索
        searchForm: {
          name: '',
        },
        searchRules: {
          name: [
            { required: true, message: "请输入公司名称", trigger: "blur" },
          ],
        },
        // 数据
        tableLoadData: [],
        limit: 10,
        page:1,// 当前页码
        total:0,//总条目数
        id: '',
        rules: {

        },
        dialogFormVisible: false,
        title: '',
        form: {
        },
        uploadImg: '',
        uploadDialog: false
      };
    },
    created() {
      this.DataList()
    },
    mounted() {

    },
    filters: {
      /**
       * @param {
       *
       * }
       */
      statusFilter(status) {
        if (status == 1) {
          return "启用";
        } else if (status == 2) {
          return "禁用";
        }
      },
      //时间格式化
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("yyyy-MM-DD HH:mm:ss");
      },

    },
    methods: {
      chooseCar(){
        this.isShowCar=true;
        //console.log('dddd',this.isShowCar)
      },
      //接收子组件传过来的值
      chooseCarInfo(car_number,...params){
        this.searchForm.name=car_number;

      },
      DataList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          page: this.page,
        }
        this.$axios.getGradeFeeRemindList(param).then(res=>{
          if(res.code == 200){
            this.tableLoadData = res.data.data
            this.total = res.data.total
          }
        }).catch(error=>{
          //console.log(error);
        })
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        this.limit = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.page = newPage
        this.DataList()
      },
      // 新增
      addData() {
        this.title = '新增'
        this.form = {
          // role_name: '',
        }
        this.dialogFormVisible = true
      },
      handelEdit(index,row) {
        this.id = index.id

        this.title = '编辑'
        this.form = {
        }
        this.dialogFormVisible = true
        // this.form = {...row};
        // 或者
        this.form = JSON.parse(JSON.stringify(index))
      },

      reset_dialogForm(formName) {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },
      searchSubmit() {
        this.page = 1
        this.DataList()
      }
    },
  };
</script>
<style>
  .table_name{
    font-weight: bold;
    /* border: 1px solid #f00; */
  }
  .table_name:hover{
    color: #409EFF;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/view/remind/gradeEstimation.vue